"use client";

import { createContext, useContext, ReactNode } from "react";

interface GlobalData {
  navbar: any;
  footer: any;
  metadata: any;
  favicon: any;
  settings: {
    pdpConfiguration?: {
      enableUserGenerateTryOn?: boolean;
    };
  };
}

const GlobalContext = createContext<GlobalData | null>(null);

export function GlobalProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: GlobalData;
}) {
  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
}

export function useGlobal() {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal must be used within GlobalProvider");
  }
  return context;
}
